interface IconProps {
    size?: number;
}

export default function OktaIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
            <circle cx="14" cy="14" r="9" stroke="#007DC1" strokeWidth="6" />
        </svg>
    );
}
